import { Tile, TileImage, TileOverlay } from '@mc/design-system'
import Image from 'components/LegacyImage'

interface HeroSingleImageTileProps {
  imgUrl: string
  imgAlt: string
}

export const HeroSingleImageTile = ({
  imgUrl,
  imgAlt,
}: HeroSingleImageTileProps) => (
  <div className='d-flex justify-content-center'>
    <div className='flex-grow-1'>
      <Tile aspectRatio='16x9'>
        <TileOverlay type='gradient-bottom' color='0,0,0' />
        <TileImage
          image={
            <Image
              src={imgUrl}
              alt={imgAlt}
              height={250}
              priority
              fetchpriority='high'
              objectFit='cover'
              objectPosition='center'
              layout='fill'
            />
          }
        />
      </Tile>
    </div>
  </div>
)
